import i18n from "./i18n";

const changeLangCustom = (lang) => {
  i18n.changeLanguage(lang);
  const now = new Date();
  const expirySeconds = 120;
  const item = {
    value: lang,
    expiry: now.getTime() + expirySeconds * 1000,
  };
  localStorage.setItem("i18nextLng", JSON.stringify(item));
};

const getLocalStorageWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};

export { changeLangCustom, getLocalStorageWithExpiry };
